<template>
  <main>
    <div class="p-4 text-xl">
      Наличности:
      <ol class="list-decimal pl-8">
        <li v-for="gift in logged_user.gifts" :key="gift.id">
          {{gift.name}} - {{gift.availability}}
        </li>
      </ol>

      <button class="btn btn-dark mt-3" @click="$router.go($router.currentRoute)">Обнови</button>
      <p class="mt-4">
        Възможно е наличностите да не са обновени поради неналична интернет връзка. <br>
        Моля, натиснете бутона "Обнови" за да опресните данните от сървъра!</p>
    </div>
  </main>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "quantities",
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters('profile',['logged_user']),
  },
  methods: {

  },
  mounted() {
    console.log(this.logged_user.gifts);
  }
};
</script>
